import {createReducer} from 'redux-act';
import {LocationPoint} from '@/common/interfaces/location';
import * as actions from './actions';

const initialState = {
	/**
	 * A plain list of recent visited locations sorted by visit time
	 */
	recentLocations: [] as LocationPoint[],
	recentLocationsLoaded: false,
	recentLocationsMaxCount: 0,

	/**
	 * A list built on the basis of the recent visited locations and their relevance for the user
	 * according to the backend algorithm
	 */
	searchHistory: [] as LocationPoint[],
	searchHistoryLoaded: false,
};

export const locationsHistoryReducer = createReducer({}, initialState);

locationsHistoryReducer
	.on(actions.fetchRecentLocationsAction.success, (state, {recentLocations, limit}) => ({
		...state,
		recentLocations,
		recentLocationsLoaded: true,
		recentLocationsMaxCount: limit,
	}))
	.on(actions.fetchSearchHistoryAction.success, (state, {searchHistory}) => ({
		...state,
		searchHistory,
		searchHistoryLoaded: true,
	}))

	.on(actions.addRecentLocationAction.request, (state, {location}) => {
		if (!state.recentLocationsLoaded) {
			return state;
		}

		const cleanCurrentList = state.recentLocations.filter(item => item.id !== location.id);
		const countLimit = state.recentLocationsMaxCount;

		return {
			...state,
			recentLocations: [location, ...cleanCurrentList].slice(0, countLimit),

			// After adding of on recent location search history list is become an non actual
			searchHistory: [],
			searchHistoryLoaded: false,
		};
	})

	.on(actions.resetSearchSuggest, state => ({
		...state,
		searchHistory: [],
		searchHistoryLoaded: false,
	}));
